import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default from 'react';
import { getStarValues } from './helpers/get-star-values.esm.js';
import { StarRatingBase } from './helpers/star-rating-base.esm.js';
import { StarRatingFilter } from './helpers/star-rating-filter.esm.js';

var _excluded = ["value", "onClick", "size", "mode", "testId"];
var defaultValue = 0;
var defaultMaxRating = 5;
var defaultSize = 'std';
function StarRating(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? defaultValue : _props$value,
    onClick = props.onClick,
    _props$size = props.size,
    size = _props$size === void 0 ? defaultSize : _props$size,
    mode = props.mode,
    testId = props.testId,
    rest = _objectWithoutProperties(props, _excluded);
  //guard clause is for perf
  if (!onClick) {
    var valueArray = getStarValues(value, defaultMaxRating);
    return /*#__PURE__*/React__default.createElement(StarRatingBase, _extends({
      mode: mode,
      valueArray: valueArray,
      size: size,
      testId: testId
    }, rest));
  }
  var tooltipContent = props.tooltipContent;
  return /*#__PURE__*/React__default.createElement(StarRatingFilter, _extends({
    size: size,
    testId: testId,
    tooltipContent: tooltipContent
  }, props));
}

export { StarRating as default };
//# sourceMappingURL=star-rating.esm.js.map
